const DEFAULT_SITE_TITLE = 'Sttok';
const DEFAULT_FAVICON = 'favicon.ico';
const DEFAULT_SITE_DESCRIPTION =
  'Sttok permite gestionar libros de socios de sociedades limitadas. Mediante Sttok de una forma fácil puedes dar de alta nuevas sociedades, dar de alta socios, dar de alta ampliaciones de capital, compraventas, planes de stock option, entre otras funcionalidades.';

export const initPageUpdate = () => {
  const siteTitle = process.env.REACT_APP_UI_SITE_TITLE || DEFAULT_SITE_TITLE;
  document.title = siteTitle;

  const siteDescription =
    process.env.REACT_APP_UI_SITE_DESCRIPTION || DEFAULT_SITE_DESCRIPTION;
  const descriptionElement = document.querySelector('meta[name="description"]');
  if (descriptionElement) {
    descriptionElement.setAttribute('content', siteDescription);
  }

  const favicon = process.env.REACT_APP_UI_FAVICON || DEFAULT_FAVICON;
  const faviconElement = document.querySelector("link[rel='icon']");
  if (faviconElement) {
    faviconElement.href = `${process.env.PUBLIC_URL}/${favicon}`;
  }
};
